import AptIndex from './apt-index.vue';
import MrIndex from './mr-index.vue';
import { ReserveType } from '@utils/itinerary';

export default defineComponent({
    setup: () => {
        definePageMeta({
            layout: 'homepage',
        });
        const packageSelectStore = usePackageSelectStoreIfInstalled();
        const { setReserveType } = useSearchFormStore();
        onMounted(() => {
            const lastSearch = localStorage.getItem(
                'lastSearch'
            ) as ReserveType;
            setReserveType(lastSearch || ReserveType.Flight);
            packageSelectStore?.clearSelectedPackages();
        });
    },
    render() {
        const { isMrbilit } = useWhiteLabel();
        const Page = isMrbilit.value ? MrIndex : AptIndex;
        return <Page />;
    },
});
